import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { extractErrorMessage } from '@/lib/errors';
import { schedulesApi } from './schedules-api';
import { SCHEDULES_KEY, scheduleSaveOptions } from './schedule-cache';

export function useSchedules(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: SCHEDULES_KEY,
    queryFn: schedulesApi.getAll,
    enabled: opts?.enabled ?? true,
  });
}

/** Saves a schedule; see `scheduleSaveOptions`. [HW-1071] */
export function useUpdateSchedule() {
  const qc = useQueryClient();
  return useMutation(
    scheduleSaveOptions(qc, schedulesApi.update, (error) =>
      toast.error(extractErrorMessage(error, 'Could not save the schedule'))
    )
  );
}
